import Button from '@doordash/component-button'
import { Text, Inline, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { Modal } from '@doordash/component-modal'
import { SafetyCourseConfirmationImage } from './images'
import { ImageContainer, ModalContentPadding } from './styles'
import { safetyCourse as t } from './strings'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'

const os = detectWebviewOs()

const ConfirmationSplash = () => (
  <Modal
    isFullScreenOnMobile
    hasCloseButton={false}
    headerImage={false}
    title={t.sections.confirmation.title()}
    renderContentHeader={({ title }) => (
      <React.Fragment>
        <ImageContainer>
          <SafetyCourseConfirmationImage />
        </ImageContainer>
        <ModalContentPadding>
          <Text styles={Text.Styles.Bold22}>{title}</Text>
        </ModalContentPadding>
      </React.Fragment>
    )}
    renderFooterContent={() => (
      <Button
        href={os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK}
      >
        {t.sections.confirmation.button()}
      </Button>
    )}
    shouldRenderStickyHeader={false}
  >
    <Text styles={Text.Styles.Medium16}>
      {t.sections.confirmation.description()}
    </Text>
  </Modal>
)

export default ConfirmationSplash
